import axios from 'axios';

/**
 * Grabs partnerdata from url json location
 *
 * @param {object} parameters
 *
 * @returns {Promise}
 */
export async function getPartnerData({ isPreview, url }: { isPreview: boolean; url: string }) {
  const axiosCors = axios.create();
  delete axiosCors.defaults.headers.common.Authorization;
  return axiosCors.get(url, {
    ...(isPreview ? { withCredentials: true } : {}),
  });
}
